export default "__VITE_ASSET__BwRGF3_L__"